import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { NetDepositLimit } from './NetDepositLimit/NetDepositLimit';

interface DepositLimitTabPropsType {
    label: string;
    customerId: number;
    permissionDepositLimits: boolean;
    currency: CurrencyType;
}

export const DepositLimitTab = observer(
    'DepositLimitTab',
    ({ customerId, permissionDepositLimits, currency }: DepositLimitTabPropsType) => {
        return (
            <div>
                <NetDepositLimit
                    currency={currency}
                    customerId={customerId}
                    permissionDepositLimits={permissionDepositLimits}
                />
            </div>
        );
    }
);
